import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import EmailStatus from "@mapmycustomers/shared/enum/EmailStatus";
import SortOrder from "@mapmycustomers/shared/enum/SortOrder";
import Email from "@mapmycustomers/shared/types/email/Email";
import EmailSchedule from "@mapmycustomers/shared/types/email/EmailSchedule";

import EmailOutboxTab from "../enums/EmailOutboxTab";

export const fetchOutboxEmails = createAsyncAction(
  "emailOutbox/fetchEmails/request",
  "emailOutbox/fetchEmails/success",
  "emailOutbox/fetchEmails/failure"
)<void, { emails: Email[]; total: number }, void>();

export const fetchOutboxStatusCounts = createAsyncAction(
  "emailOutbox/fetchStatusCounts/request",
  "emailOutbox/fetchStatusCounts/success",
  "emailOutbox/fetchStatusCounts/failure"
)<void, Record<EmailStatus, number>, void>();

export const setOutboxActiveTab = createAction("emailOutbox/setActiveTab")<EmailOutboxTab>();

export const setOutboxPage = createAction("emailOutbox/setPage")<number>();

export const setOutboxSearch = createAction("emailOutbox/setSearch")<string>();

export const setOutboxSort = createAction("emailOutbox/setSort")<{
  fieldName: string;
  order: SortOrder;
}>();

export const cancelScheduledEmail = createAction("emailOutbox/cancelScheduledEmail")<{
  emailId: Email["id"];
}>();

export const deleteFailedEmail = createAction("emailOutbox/deleteFailedEmail")<{
  emailId: Email["id"];
}>();

export const rescheduleEmail = createAction("emailOutbox/rescheduleEmail")<{
  emailId: Email["id"];
  schedule: EmailSchedule;
}>();

export const retryFailedEmail = createAction("emailOutbox/retryFailedEmail")<{
  emailId: Email["id"];
}>();

export const clearEmailList = createAction("emailOutbox/clearEmailList")<{
  status: EmailStatus.CANCELLED | EmailStatus.ERRORED;
}>();

export type Actions = ActionType<
  | typeof cancelScheduledEmail
  | typeof clearEmailList
  | typeof deleteFailedEmail
  | typeof fetchOutboxEmails
  | typeof fetchOutboxStatusCounts
  | typeof rescheduleEmail
  | typeof retryFailedEmail
  | typeof setOutboxActiveTab
  | typeof setOutboxPage
  | typeof setOutboxSearch
  | typeof setOutboxSort
>;
